export const GEOCODING_ROOT_QUERY_KEY = "geocoding"
